/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentEditorsAssociatedCompaniesAssociatedcompanyidFinancialEdit200,
  GetApiV1IndividualpaymentEditorsAssociatedCompaniesAssociatedcompanyidFinancialEdit401,
  GetApiV1IndividualpaymentEditorsAssociatedCompaniesAssociatedcompanyidFinancialEdit404,
  GetApiV1IndividualpaymentEditorsAssociatedCompaniesAssociatedcompanyidFinancialEdit500,
  GetApiV1IndividualpaymentEditorsAssociatedCompaniesAssociatedcompanyidFinancialEditPathParams,
  GetApiV1IndividualpaymentEditorsAssociatedCompaniesAssociatedcompanyidFinancialEditQueryResponse,
} from "../../types/individualPaymentEditorsController/GetApiV1IndividualpaymentEditorsAssociatedCompaniesAssociatedcompanyidFinancialEdit.ts";
import { individualPaymentAssociatedCompanyViewModelSchema } from "../individualPaymentAssociatedCompanyViewModelSchema.ts";

export const getApiV1IndividualpaymentEditorsAssociatedCompaniesAssociatedcompanyidFinancialEditPathParamsSchema =
  z.object({
    associatedCompanyId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1IndividualpaymentEditorsAssociatedCompaniesAssociatedcompanyidFinancialEditPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentEditorsAssociatedCompaniesAssociatedcompanyidFinancialEdit200Schema =
  z.lazy(
    () => individualPaymentAssociatedCompanyViewModelSchema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentEditorsAssociatedCompaniesAssociatedcompanyidFinancialEdit200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentEditorsAssociatedCompaniesAssociatedcompanyidFinancialEdit401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentEditorsAssociatedCompaniesAssociatedcompanyidFinancialEdit401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1IndividualpaymentEditorsAssociatedCompaniesAssociatedcompanyidFinancialEdit404Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentEditorsAssociatedCompaniesAssociatedcompanyidFinancialEdit404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentEditorsAssociatedCompaniesAssociatedcompanyidFinancialEdit500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentEditorsAssociatedCompaniesAssociatedcompanyidFinancialEdit500>;

export const getApiV1IndividualpaymentEditorsAssociatedCompaniesAssociatedcompanyidFinancialEditQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1IndividualpaymentEditorsAssociatedCompaniesAssociatedcompanyidFinancialEdit200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentEditorsAssociatedCompaniesAssociatedcompanyidFinancialEditQueryResponse>;
